import React from 'react';
import Layout from 'layout/Layout';
import ReservationDetailComponent from 'components/ReservationDetailComponent';

const ReservationDetailPage: React.FC = () => {
  const pageTitle = '予約内容確認';

  return (
    <Layout pageTitle={pageTitle}>
      <ReservationDetailComponent></ReservationDetailComponent>
    </Layout>
  );
};
export default ReservationDetailPage;
